const Banner = () => {
    return (
        <section id="welcome-section" className="page_section">
            <div id="welcome-tag">
                <h1>Hello, I'm  Daniel Smathers</h1>
                <h2>A Web Developer located in Portland, Oregon</h2>
            </div>
        </section>
    )
}

export default Banner
